import { render } from "./NavNotif.vue?vue&type=template&id=4d17ce70"
import script from "./NavNotif.vue?vue&type=script&lang=js"
export * from "./NavNotif.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/project-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__